import { render, staticRenderFns } from "./LogoAlignment.vue?vue&type=template&id=948b23fc&"
import script from "./LogoAlignment.vue?vue&type=script&lang=js&"
export * from "./LogoAlignment.vue?vue&type=script&lang=js&"
import style0 from "./LogoAlignment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports